module.exports = __webpack_public_path__ + "img/logo_4.0c56cdde.svg";